import type { InferOutput } from "valibot";

declare global { const typesense: Typesense; }

export const typesenseSchema = v.object({
  nodes: v.array(v.object({
    url: v.pipe(v.string(), v.url()),
  })),
  apiKey: v.string(),
});
export type Typesense = InferOutput<typeof typesenseSchema>;
